import { createReducer } from "./../../../redux/reducers/functions";

import {
  PRESENCE_SET_STATUS,
  PRESENCE_SET_VACATION_TYPES,
  PRESENCE_SET_BALANCE,
  PRESENCE_SET_SELECTEDUSER_VACATIONS,
  PRESENCE_SET_LIST_VACATIONS,
  PRESENCE_IS_LOADING
} from "../actions/presence";

const initialState = {
  selectedUserBalance: { total: "n/c", available: "n/c", pending: "n/c" },
  types: [],
  absenceTypes: [],
  vacationTypes: [],
  vacationRequests: [],
  selectedUserVacations: [], // pour le planning, liste des vacations du user selectionné pour le format planning
  isLoading: false
};

const status = {
  [PRESENCE_SET_STATUS]: (state, action) => {
    return Object.assign({}, state, {
      presence_id: action.id,
      presence_status: action.status
    });
  }
};
const vacationBalance = {
  [PRESENCE_SET_BALANCE]: (state, action) => {
    const selectedUserBalance = action.payload;
    return { ...state, selectedUserBalance };
  }
};
const vacationTypes = {
  [PRESENCE_SET_VACATION_TYPES]: (state, action) => {
    const types = action.payload;

    if (Array.isArray(types))
      return {
        ...state,
        types,
        absenceTypes: types.filter(type => type.absence),
        vacationTypes: types.filter(type => type.vacation)
      };
    return state;
  }
};

const vacations = {
  [PRESENCE_SET_SELECTEDUSER_VACATIONS]: (state, action) => {
    const vacations = action.payload;
    if (Array.isArray(vacations)) return { ...state, selectedUserVacations: vacations };
    return state;
  }
};

const vacationRequests = {
  [PRESENCE_SET_LIST_VACATIONS]: (state, action) => {
    const vacationRequests = action.payload;
    if (Array.isArray(vacationRequests)) return { ...state, vacationRequests };
    return state;
  }
};

const isLoading = {
  [PRESENCE_IS_LOADING]: (state, action) => {
    return { ...state, isLoading: action.payload };
  }
};
const presenceReducer = createReducer(initialState, {
  ...status,
  ...vacationTypes,
  ...vacationBalance,
  ...vacations,
  ...vacationRequests,
  ...isLoading
});

export default presenceReducer;



// WEBPACK FOOTER //
// src/modules/presence/reducers/presence.js